var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twitter logo",
    clipPath: "url(#clip0_2069_867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.9 2.54125C19.1586 2.85417 18.3722 3.05957 17.5669 3.15062C18.4057 2.67167 19.0497 1.91324 19.353 1.00958C18.5556 1.46037 17.6832 1.77798 16.7735 1.94869C16.0325 1.19659 14.9768 0.726562 13.8084 0.726562C11.565 0.726562 9.74608 2.45932 9.74608 4.59645C9.74608 4.8998 9.78204 5.19513 9.85126 5.47844C6.47522 5.317 3.48202 3.77634 1.47844 1.43496C1.12884 2.00653 0.928524 2.67138 0.928524 3.38051C0.928524 4.72318 1.64573 5.90765 2.73566 6.60168C2.09057 6.58243 1.45968 6.41645 0.895653 6.11758C0.895421 6.13379 0.895421 6.15 0.895421 6.16628C0.895421 8.04132 2.29565 9.60548 4.15391 9.96101C3.55572 10.116 2.92826 10.1387 2.31947 10.0273C2.83636 11.5648 4.33659 12.6836 6.1141 12.7149C4.72385 13.7529 2.97225 14.3716 1.06914 14.3716C0.741198 14.3716 0.417902 14.3532 0.100098 14.3175C1.89779 15.4155 4.03302 16.0562 6.32703 16.0562C13.799 16.0562 17.8848 10.1592 17.8848 5.04525C17.8848 4.8774 17.8809 4.71051 17.873 4.54457C18.6683 3.99687 19.3547 3.31848 19.9 2.54125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2069_867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.7999,
    height: 15.4,
    fill: "white",
    transform: "translate(0.100098 0.666504)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.17c3c839b296725ce2030de99ba4666e.svg";
export { ForwardRef as ReactComponent };